/* eslint-disable prettier/prettier */
import Vue from "vue";
import Vuex from "vuex";
import nearcodeService from "@/apis/nearcodeService";
import router from "../router";
import VueSweetalert2 from 'vue-sweetalert2';

// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';
Vue.use(VueSweetalert2);

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    weather: [],
    jobs: [],
    token: [],
    loggedUser: [],
    applications: [],
    applicationsSkills: [],
    users: [],
    actualJob: "",
    cv: "",
    skills: [],
    pages: [],
    content: []
  },
  mutations: {
    SET_JOBS(state, data) {
      if (data.status == 403) {
        state.token = []
        state.loggedUser = []
        localStorage.removeItem("token", JSON.stringify(state.token));
        router.push({
          name: 'Login'
        })
      } else {
        state.jobs = data;
      }
    },
    LOGIN(state, data) {
      if (data.message == undefined) {
        state.token = data.token
        localStorage.setItem("token", state.token);
        let jwtToken = state.token.split(".")[1]
        state.loggedUser = JSON.parse(window.atob(jwtToken))
        if (state.loggedUser.first_login === 0 && state.loggedUser.state === 0) {
          /*  this.$swal("Troque a sua palavra passe") */
          router.push("/profile")
        } else if (state.loggedUser.state === 0) {
          router.push("/")
        } else {
          alert("Não tem autorização para entrar")
        }
      } else {
        Vue.swal({
          title: data.message,
          icon: "error",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Ok!",
        })
      }
    },
    SET_APPLICATIONS(state, data) {
      if (data.status == 403) {
        state.token = []
        state.loggedUser = []
        localStorage.removeItem("token", JSON.stringify(state.token));
        router.push({
          name: 'Login'
        })
      } else {
        state.applications = data
      }
    },
    SET_APPLICATIONS_SKILLS(state, data) {
      if (data.status == 403) {
        state.token = []
        state.loggedUser = []
        localStorage.removeItem("token", JSON.stringify(state.token));
        router.push({
          name: 'Login'
        })
      } else {
        state.applicationsSkills = data
      }
    },
    SET_USERS(state, data) {
      if (data.status == 403) {
        state.token = []
        state.loggedUser = []
        localStorage.removeItem("token", JSON.stringify(state.token));
        router.push({
          name: 'Login'
        })
      } else {
        state.users = data
      }
    },
    LOGOUT(state) {
      state.token = []
      state.loggedUser = []
      localStorage.removeItem("token", JSON.stringify(state.token));
      router.push({
        name: 'Login'
      })
    },
    ADD_USER() {
      router.push({
        name: 'Home'
      })
    },
    ADD_JOBS() {},
    EDIT_USER_TYPE() {},
    EDIT_USER_STATE() {},
    SET_CV(state, data) {
      state.cv = data

    },
    EDIT_JOB_STATE() {},
    EDIT_COMMENT() {},
    EDIT_INTEREST() {},
    SET_SKILLS(state, data) {
      if (data.status == 403) {
        state.token = []
        state.loggedUser = []
        localStorage.removeItem("token", JSON.stringify(state.token));
        router.push({
          name: 'Login'
        })
      } else {
        state.skills = data
      }
    },
    DELETE_USER() {},
    DELETE_JOBS() {},
    DELETE_APPLICATION() {},
    SEND_CANDIDATE_EMAIL() {},
    SEND_ALL_CANDIDATE_EMAIL() {},
    EDIT_PASSWORD() {},
    ADD_CONTENT() {},
    SET_PAGES(state, data) {
      if (data.status == 403) {
        state.token = []
        state.loggedUser = []
        localStorage.removeItem("token", JSON.stringify(state.token));
        router.push({
          name: 'Login'
        })
      } else {
        state.pages = data.data
      }
    },
    SET_CONTENT(state, data) {
      if (data.status == 403) {
        state.token = []
        state.loggedUser = []
        localStorage.removeItem("token", JSON.stringify(state.token));
        router.push({
          name: 'Login'
        })
      } else {
        state.content = data
      }
    },
    DELETE_CONTENT() {},
    EDIT_CONTENT() {},
    ADD_SKILL() {},
    DELETE_SKILL() {},
    ADD_SKILL_TO_CANDIDATE() {}
  },
  actions: {
    async fetchJobs({
      commit
    }) {
      commit("SET_JOBS", await nearcodeService.getJobs())
    },
    async login({
      commit
    }, payload) {
      commit("LOGIN", await nearcodeService.login(payload.email, payload.password))
    },
    async fetchApplications({
      commit
    }) {
      commit("SET_APPLICATIONS", await nearcodeService.getApplications())
    },
    async fetchApplicationsSkills({
      commit
    }) {
      commit("SET_APPLICATIONS_SKILLS", await nearcodeService.getAppSkills())
    },
    async fetchUsers({
      commit
    }) {
      commit("SET_USERS", await nearcodeService.getUsers())
    },
    async postUser({
      commit
    }, payload) {
      commit("ADD_USER", await nearcodeService.registerUser(payload.username, payload.email, payload.password, payload.confPassword))
    },
    async postJobs({
      commit
    }, payload) {
      commit("ADD_JOBS", await nearcodeService.addJob(payload.name, payload.description, payload.profile, payload.offer, payload.state))
    },
    async putUserType({
      commit
    }, payload) {
      commit("EDIT_USER_TYPE", await nearcodeService.editUserType(payload.id))
    },
    async putUserState({
      commit
    }, payload) {
      commit("EDIT_USER_STATE", await nearcodeService.editUserState(payload.id))
    },
    async getCurriculum({
      commit
    }, payload) {
      commit("SET_CV", await nearcodeService.getCv(payload.id))
    },
    async putJobState({
      commit
    }, payload) {
      commit("EDIT_JOB_STATE", await nearcodeService.editJobState(payload.id))
    },
    async putComment({
      commit
    }, payload) {
      commit("EDIT_COMMENT", await nearcodeService.editCandidate(payload.id, payload.comments))
    },
    async putInterest({
      commit
    }, payload) {
      commit("EDIT_INTEREST", await nearcodeService.editInterest(payload.id, payload.interest))
    },
    async fetchSkills({
      commit
    }) {
      commit("SET_SKILLS", await nearcodeService.getSkills())
    },
    async deleteUser({
      commit
    }, payload) {
      commit("DELETE_USER", await nearcodeService.deleteUser(payload.id))
    },
    async deleteJob({
      commit
    }, payload) {
      commit("DELETE_JOBS", await nearcodeService.deleteJob(payload.id))
    },
    async deleteApplication({
      commit
    }, payload) {
      commit("DELETE_APPLICATION", await nearcodeService.deleteApplication(payload.id))
    },
    async fetchSendEmailCandidate({
      commit
    }, payload) {
      commit("SEND_CANDIDATE_EMAIL", await nearcodeService.sendEmailCandidate(payload.id))
    },
    async editPassword({
      commit
    }, payload) {
      commit("EDIT_PASSWORD", await nearcodeService.editPassword(payload.id, payload.oldPassword, payload.newPassword, payload.newPassword2))
    },
    async postContent({
      commit
    }, payload) {
      commit("ADD_CONTENT", await nearcodeService.postContent(payload.title, payload.description, payload.titleEn, payload.descriptionEn, payload.img, payload.idPage))
    },
    async fetchPages({
      commit
    }) {
      commit("SET_PAGES", await nearcodeService.getPages())
    },
    async fetchContent({
      commit
    }) {
      commit("SET_CONTENT", await nearcodeService.getContent())
    },
    async deleteContent({
      commit
    }, payload) {
      commit("DELETE_CONTENT", await nearcodeService.deleteContent(payload.id))
    },
    async putContent({
      commit
    }, payload) {
      commit("EDIT_CONTENT", await nearcodeService.putContent(payload.id, payload.title, payload.description, payload.titleEn, payload.descriptionEn, payload.img))
    },
    async addSkills({
      commit
    }, payload) {
      commit("ADD_SKILLS", await nearcodeService.addSkill(payload.name))
    },
    async delSkills({
      commit
    }, payload) {
      commit("DELETE_SKILL", await nearcodeService.deleteSkill(payload.id))
    },
    async fetchSendEmailAllCandidates({
      commit
    }, payload) {
      commit("SEND_ALL_CANDIDATE_EMAIL", await nearcodeService.sendEmailAllCandidate(payload.id))
    },
    async addSkillToCandidate({
      commit
    }, payload) {
      commit("SEND_ALL_CANDIDATE_EMAIL", await nearcodeService.addSkillsToCandidate(payload.id, payload.skills))
    }
  },
  getters: {
    getWeather: state => state.weather,
    getJobs: state => state.jobs,
    getApplications: state => state.applications,
    getAppSkills: state => state.applicationsSkills,
    getUsers: state => state.users,
    getName(state) {
      if (localStorage.getItem("token")) {
        state.token = localStorage.getItem("token");
        let jwtToken = state.token.split(".")[1]
        state.loggedUser = JSON.parse(window.atob(jwtToken))
        return state.loggedUser.username
      }
    },
    getUserData(state) {
      if (localStorage.getItem("token")) {
        state.token = localStorage.getItem("token");
        let jwtToken = state.token.split(".")[1]
        state.loggedUser = JSON.parse(window.atob(jwtToken))
        return state.loggedUser
      }
    },
    getType(state) {
      state.token = localStorage.getItem("token");
      let jwtToken = state.token.split(".")[1]
      state.loggedUser = JSON.parse(window.atob(jwtToken))
      return state.loggedUser.type
    },
    getCurriculum: state => state.cv,
    getSkills: state => state.skills,
    getPages: state => state.pages,
    getContent: state => state.content,
  },
  modules: {}
});